import styled from "styled-components";


export const FooterContainer = styled.div`
  padding: 30px 0;
  display: flex;
  justify-content: center;
  flex-direction: column;

  p {
    text-align: center;
    font-size: 18px;
    color: white;
  }
  img {
    height: 100px;
    aspect-ratio: 4/3; 
    object-fit: contain;
  }
`;